import {EmpPopulationCriterion, RepPopulationCriterion} from './user-rights.interfaces';

import {FieldZone} from '../../+reports/reports.interfaces';

export const mockContractIndexCriteria = [
  {
    id: 251628,
    cliCoreId: 22,
    dataIndice: 1,
    name: 'empContract.payroll',
    type: 'FLATTEN_FIELD'
  },
  {
    id: 251688,
    cliCoreId: 22,
    dataIndice: 11,
    name: 'ConfidentialityLevel',
    type: 'FLATTEN_FIELD'
  },
  {
    id: 251689,
    cliCoreId: 22,
    dataIndice: 12,
    name: 'Position',
    type: 'FLATTEN_FIELD'
  },
  {
    id: 251690,
    cliCoreId: 22,
    dataIndice: 15,
    name: 'HiringStatus',
    type: 'FLATTEN_FIELD'
  },
  {
    id: 251691,
    cliCoreId: 22,
    dataIndice: 16,
    name: 'cliEmp.birthDate',
    type: 'FLATTEN_FIELD'
  },
  {
    id: 251692,
    cliCoreId: 22,
    dataIndice: 17,
    name: 'ReasonForBeginningContract',
    type: 'FLATTEN_FIELD'
  }
];

export const mockCriteriaDescriptors = [
  {
    zoneID: 'empContract.payroll',
    zoneGroup: 'Contract',
    dataIndice: 1,
    type: 'BOOLEAN',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Taken into account in payroll'
    ],
    metadatas: {
      structureType: 'EMP'
    }
  },
  {
    zoneID: 'ConfidentialityLevel',
    zoneGroup: 'ConfidentialityLevel',
    dataIndice: 11,
    type: 'LIST',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Confidentiality level'
    ],
    metadatas: {
      items: [
        {
          value: 'Medium',
          display: 'Medium (HR department)',
          selectable: true
        },
        {
          value: 'Normal',
          display: 'Normal',
          selectable: true
        },
        {
          value: 'High',
          display: 'High (Executive)',
          selectable: true
        }
      ],
      structureType: 'EMP'
    }
  },
  {
    zoneID: 'Position',
    zoneGroup: 'Position',
    dataIndice: 12,
    type: 'ENTITY',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Position'
    ],
    metadatas: {
      rel: '/ga/api/v1/entity/getRepEntitiesShortViewByTree?tree=Positions',
      structureType: 'EMP'
    }
  },
  {
    zoneID: 'HiringStatus',
    zoneGroup: 'HiringStatus',
    dataIndice: 15,
    type: 'LIST',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Hire status'
    ],
    metadatas: {
      items: [
        {
          value: 'InitiatedViaMSS',
          display: 'Initiated via MSS',
          selectable: true
        },
        {
          value: 'Validated',
          display: 'Validated',
          selectable: true
        }
      ],
      structureType: 'EMP'
    }
  },
  {
    zoneID: 'cliEmp.birthDate',
    zoneGroup: 'Birth',
    dataIndice: 16,
    type: 'DATE',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Date of birth'
    ],
    metadatas: {
      structureType: 'EMP'
    }
  },
  {
    zoneID: 'ReasonForBeginningContract',
    zoneGroup: 'Contract',
    dataIndice: 17,
    type: 'TREE',
    readOnly: false,
    hidden: false,
    required: false,
    transIds: [
      'Reason for beginning of contract'
    ],
    metadatas: {
      items: [
        {
          value: '005',
          display: 'CDD',
          selectable: true
        },
        {
          value: '013',
          display: 'Changement de statut CCSS',
          selectable: true
        },
        {
          value: '020',
          display: 'Changement horaire de travail',
          selectable: false
        }],
      structureType: 'EMP'
    }
  }
];

export const mockContractIndexCriteriaZones = [
  {
    id: 'empContract.payroll',
    text: 'Taken into account in payroll',
    descriptionTransId: [
      'Taken into account in payroll'
    ]
  },
  {
    id: 'ConfidentialityLevel',
    text: 'Confidentiality level',
    descriptionTransId: [
      'Confidentiality level'
    ]
  },
  {
    id: 'Position',
    text: 'Position',
    descriptionTransId: [
      'Position'
    ]
  },
  {
    id: 'HiringStatus',
    text: 'Hire status',
    descriptionTransId: [
      'Hire status'
    ]
  },
  {
    id: 'cliEmp.birthDate',
    text: 'Date of birth',
    descriptionTransId: [
      'Date of birth'
    ]
  },
  {
    id: 'ReasonForBeginningContract',
    text: 'Reason for beginning of contract',
    descriptionTransId: [
      'Reason for beginning of contract'
    ]
  }
];

export const mockPopulationAccessCriterionPayloadForListType: EmpPopulationCriterion = {
  zoneName: 'ConfidentialityLevel',
  access: 'READ',
  value: {
    ConfidentialityLevel: {
      type: 'LIST',
      value: 'Medium',
      transId: 'Medium (HR department)'
    }
  },
  groupZoneName: 'ConfidentialityLevel',
  contractIndexCriteriaMapping: {
    data: '11',
    value: 'Medium'
  }
};

export const mockPopulationAccessCriterion: EmpPopulationCriterion[] = [{
  ...mockPopulationAccessCriterionPayloadForListType
}];

export const mockPopulationAccessCriterionPayloadForEntityType: EmpPopulationCriterion = {
  zoneName: 'Position',
  access: 'WRITE',
  value: {
    Position: {
      type: 'ENTITY',
      value: 3000043422,
      transId: 'Administrative Assistant NL 1'
    }
  },
  groupZoneName: 'Position',
  contractIndexCriteriaMapping: {
    data: '12',
    value: 3000043422
  }
};

export const mockPopulationAccessCriterionPayloadForTreeType: EmpPopulationCriterion = {
  zoneName: 'ReasonForBeginningContract',
  access: 'READ',
  value: {
    ReasonForBeginningContract: {
      type: 'TREE',
      value: '013',
      transId: 'Changement de statut CCSS'
    }
  },
  groupZoneName: 'Contract',
  contractIndexCriteriaMapping: {
    data: '17',
    value: '013'
  }
};

export const mockPopulationAccessCriterionPayloadForDefaultType: EmpPopulationCriterion = {
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: {
    'empContract.payroll': {
      type: 'BOOLEAN',
      value: true,
      transId: true
    }
  },
  groupZoneName: 'Contract',
  contractIndexCriteriaMapping: {
    data: '1',
    value: true
  }
};

export const mockPopulationAccessCriterionPayloadForDefaultTypeFalse: EmpPopulationCriterion = {
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: {
    'empContract.payroll': {
      type: 'BOOLEAN',
      value: false,
      transId: false
    }
  },
  groupZoneName: 'Contract',
  contractIndexCriteriaMapping: {
    data: '1',
    value: false
  }
};

export const mockSelectedEmpPopulationCriterionZone: EmpPopulationCriterion = {
  id: 8053,
  zoneName: 'HiringStatus',
  groupZoneName: 'HiringStatus',
  value: {
    HiringStatus: {
      value: 'Validated',
      type: 'LIST',
      transId: 'Validated'
    }
  },
  access: 'READ',
  contractIndexCriteriaMapping: {
    data: '7',
    value: 'Validated'
  }
};

export const mockEntityAccessCriterion: RepPopulationCriterion[] = [{
  id: 1111,
  zoneName: 'Location.Country',
  access: 'WRITE',
  value: {
    'Location.Country': {
      value: 'IN',
      type: 'LIST',
      transId: 'India'
    }
  },
  entityType: 'Locations',
  groupZoneName: 'LocationAddress'
},
  {
    id: 2222,
    zoneName: 'DocumentsOfficialSignerReferenceMVEL',
    access: 'WRITE',
    value: {
      'DocumentsOfficialSignerReferenceMVEL': {
        value: 'France',
        type: 'ENTITY',
        transId: 'France'
      }
    },
    entityType: 'Document',
    groupZoneName: 'DocumentsLibraryMVEL.link.OfficialSigners'
  },
  {
    id: 3333,
    zoneName: 'DocumentsLibraryReferenceMVEL',
    access: 'WRITE',
    value: {
      'DocumentsLibraryReferenceMVEL': {
        value: 'DescriptionCompanyCarCertificate',
        type: 'TREE',
        transId: 'Company car'
      }
    },
    entityType: 'Document',
    groupZoneName: 'DocumentsLibraryMVEL.link.OfficialSigners'
  },
  {
    id: 4444,
    zoneName: 'PayrollSet.ActivateMysdworx',
    access: 'WRITE',
    value: {
      'PayrollSet.ActivateMysdworx': {
        value: 'true',
        type: 'BOOLEAN',
        transId: true
      }
    },
    entityType: 'PayrollSet',
    groupZoneName: 'PortalSettings'
  }];

export const mockEntityAccessCriterionPayloadForDefaultTypeNotBoolean: RepPopulationCriterion = {
  entityType: '',
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: {
    'empContract.payroll': {
      type: 'TEST',
      value: 'test',
      transId: 'test'
    }
  },
  groupZoneName: 'Contract'
};

export const mockEntityAccessCriterionPayloadForDefaultTypeNull: RepPopulationCriterion = {
  entityType: '',
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: null,
  groupZoneName: 'Contract'
};

export const mockEntityAccessCriterionPayloadForDefaultType: RepPopulationCriterion = {
  entityType: '',
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: {
    'empContract.payroll': {
      type: 'BOOLEAN',
      value: true,
      transId: true
    }
  },
  groupZoneName: 'Contract'
};

export const mockEntityAccessCriterionPayloadForDefaultTypeFalse: RepPopulationCriterion = {
  entityType: '',
  zoneName: 'empContract.payroll',
  access: 'READ',
  value: {
    'empContract.payroll': {
      type: 'BOOLEAN',
      value: false,
      transId: false
    }
  },
  groupZoneName: 'Contract'
};

export const mockEntityFormDescriptors = {
  formDescriptor: {
    tabSheets: [
      {
        tabSheetID: 'rep_activity_70',
        transId: 'Activity',
        tabSheetPosition: 70,
        groupZones: []
      },
      {
        tabSheetID: 'rep_identification_10',
        transId: 'Identification',
        tabSheetPosition: 10,
        groupZones: [
          {
            groupZoneID: 'OrganizationManagementResponsibleHR',
            transId: 'Management HR',
            zones: [
              {
                zoneID: 'OrganizationResponsibleHR:manager',
                transId: 'Responsible HR (ID)',
                readOnly: false,
                hidden: false,
                metadatas: {
                  rel: '/ga/api/v1/peopleTree/getNodesForPeopleManage?treeType=PayrollOrganization'
                },
                type: 'PEOPLE_TREE',
                zoneGroup: 'OrganizationManagementResponsibleHR',
                isRequired: false,
                isKeyZone: false
              }
            ],
          },
          {
            groupZoneID: 'OrganizationReportingIdentification',
            transId: 'Identification for reporting',
            metadatas: {},
            zones: [
              {
                zoneID: 'OrganizationReportingIdentification.TypeOfUO',
                transId: 'Type of business unit',
                readOnly: false,
                hidden: false,
                metadatas: {
                  items: [
                    {
                      value: 'Division',
                      display: '2. Division',
                      selectable: true
                    },
                    {
                      value: 'SubSection',
                      display: '5. Sub-section',
                      selectable: true
                    },
                    {
                      value: 'Department',
                      display: '3. Department',
                      selectable: true
                    },
                    {
                      value: 'Section',
                      display: '4. Section',
                      selectable: true
                    },
                    {
                      value: 'Branch',
                      display: '1. Branch',
                      selectable: true
                    }
                  ]
                },
                type: 'LIST',
                zoneGroup: 'OrganizationReportingIdentification',
              }
            ],
          }
        ]
      },
    ],
  }
};

export const mockEntityTreeNameItems = [
  {
    id: 181916,
    name: 'Organization',
    transId: 'Business units',
    type: 'ORGANIZATION',
    supportLevel: false,
    displayByDefault: false,
    visibleLevels: 3,
    allowGeneratedName: false,
    links: [
      {
        rel: 'entities',
        href: '/ga/api/v1/entity/getRepEntitiesShortViewByTree?tree=Organization',
        type: 'GET'
      }
    ],
    gloRegId: 101,
    parentTypeDelete: false,
    parentTypeReplace: false,
    parentTypeNa: true
  },
  {
    id: 184313,
    name: 'LegalOrganization',
    transId: 'Legal organization',
    type: 'ORGANIZATION',
    supportLevel: true,
    displayByDefault: true,
    visibleLevels: 3,
    allowGeneratedName: false,
    links: [
      {
        rel: 'entities',
        href: '/ga/api/v1/entity/getRepEntitiesShortViewByTree?tree=LegalOrganization',
        type: 'GET'
      }
    ],
    gloRegId: 101,
    parentTypeDelete: false,
    parentTypeReplace: false,
    parentTypeNa: true
  }
];

// PayrollSet - BOOLEAN, LABEL, TEXT, DATE
// LegalOrganization - LIST, TREE, ENTITY
const mockRawEntityReportingFields: FieldZone[] = [
  {
    name: 'PayrollSet',
    transIds: [
      'Pay groups'
    ],
    types: [],
    items: [{
      name: 'Settings',
      transIds: [
        'Settings'
      ],
      types: [],
      items: [
      {
        name: 'PortalSettings',
        groupZoneType: 'UNIQUE_NON_MANDATORY',
        transIds: [
          'portal_settings'
        ],
        types: [],
        items: [
          {
            name: 'PayrollSet.ActivateMysdworx',
            transIds: [
              'Activate_Mysdworx'
            ],
            types: [
              'BOOLEAN'
            ]
          }
        ]
      },
      {
        name: 'PayrollSetsIdentification',
        groupZoneType: 'UNIQUE_MANDATORY',
        transIds: [
          'Identification'
        ],
        types: [],
        items: [
          {
            name: 'PayrollSets.Name',
            transIds: [
              'Name'
            ],
            types: [
              'LABEL'
            ]
          },
          {
            name: 'PayrollSetPayrollKey',
            transIds: [
              'Payroll key'
            ],
            types: [
              'TEXT'
            ]
          }
        ]
      },
      {
        name: 'GoLive',
        groupZoneType: 'UNIQUE_NON_MANDATORY',
        transIds: [
          'Go-Live'
        ],
        types: [],
        items: [
          {
            name: 'GoLiveDate',
            transIds: [
              'Go-Live date'
            ],
            types: [
              'DATE'
            ]
          }
        ]
      }
    ]
    }]
  },
  {
    name: 'LegalOrganization',
    transIds: [
      'Legal organization'
    ],
    types: [],
    items: [
      {
        name: 'Document',
        transIds: [
          'Document'
        ],
        types: [],
        items: [
          {
            name: 'DocumentsLibraryMVEL.link.OfficialSigners',
            groupZoneType: 'MULTIPLE_NON_MANDATORY',
            transIds: [
              'Official signers'
            ],
            types: [],
            items: [
              {
                name: 'DocumentsLibraryReferenceMVEL',
                transIds: [
                  'Documents library v/ Official signers',
                  'Documents library type'
                ],
                types: [
                  'TREE'
                ],
                metadatas: {
                  items: [
                    {
                      value: 'DocumentType',
                      display: 'Document type',
                      selectable: false
                    },
                    {
                      value: 'DescriptionCompanyCarCertificate',
                      display: 'Company car',
                      selectable: true,
                      parentValue: 'AdministrativeCertificatesCategory'
                    },
                    {
                      value: 'DescriptionHealthInsuranceCertificate',
                      display: 'Health insurance certificate',
                      selectable: true,
                      parentValue: 'AdministrativeCertificatesCategory'
                    }
                  ]
                }
              },
              {
                name: 'DocumentsOfficialSignerReferenceMVEL',
                transIds: [
                  'Official signer'
                ],
                types: [
                  'ENTITY'
                ],
                metadatas: {
                  rel: '/ga/api/v1/entity/getRepEntitiesShortViewByTree?tree=OfficialSigners'
                }
              }
            ]
          },
        ]
      },
      {
        name: 'Establishment',
        transIds: [
          'Establishment'
        ],
        types: [],
        items: [
          {
            name: 'EstablishmentIdentification',
            groupName: 'EstablishmentIdentification',
            groupZoneType: 'UNIQUE_MANDATORY',
            transIds: [
              'Identification'
            ],
            types: [],
            items: [
              {
                name: 'LegalOrganization.Establishment.Name',
                transIds: [
                  'Name'
                ],
                types: [
                  'LABEL'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.AttachmentFile',
                transIds: [
                  'Attachment File'
                ],
                types: [
                  'FILE'
                ]
              }
            ]
          },
          {
            name: 'EstablishmentNumberOfEmployees',
            groupName: 'EstablishmentNumberOfEmployees',
            groupZoneType: 'UNIQUE_NON_MANDATORY',
            transIds: [
              'Number of employees'
            ],
            types: [],
            items: [
              {
                name: 'LegalOrganization.Establishment.NumberOfEmployees',
                transIds: [
                  'Number of employees'
                ],
                types: [
                  'INTEGER'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.FTE',
                transIds: [
                  'FTE'
                ],
                types: [
                  'DECIMAL'
                ]
              }
            ]
          },
          {
            name: 'EstablishmentAddress',
            groupName: 'EstablishmentAddress',
            groupZoneType: 'UNIQUE_MANDATORY',
            transIds: [
              'Address'
            ],
            types: [],
            items: [
              {
                name: 'LegalOrganization.Establishment.ZipCode',
                transIds: [
                  'Zip code'
                ],
                types: [
                  'LABEL'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.Country',
                transIds: [
                  'Country'
                ],
                types: [
                  'LIST'
                ],
                metadatas: {
                  items: [
                    {
                      value: 'FR',
                      display: 'France',
                      selectable: true
                    },
                    {
                      value: 'IN',
                      display: 'India',
                      selectable: true
                    }
                  ]
                }
              },
              {
                name: 'LegalOrganization.Establishment.AddressLine1',
                transIds: [
                  'Establishment address 1'
                ],
                types: [
                  'LABEL'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.AddressLine2',
                transIds: [
                  'Establishment address 2'
                ],
                types: [
                  'LABEL'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.City',
                transIds: [
                  'City'
                ],
                types: [
                  'LABEL'
                ]
              },
              {
                name: 'LegalOrganization.Establishment.AddressLine3',
                transIds: [
                  'Establishment address 3'
                ],
                types: [
                  'LABEL'
                ]
              }
            ]
          },
          {
            name: 'EstablishmentCalculationOptions',
            groupName: 'EstablishmentCalculationOptions',
            groupZoneType: 'UNIQUE_MANDATORY',
            transIds: [
              'Calculation options'
            ],
            types: []
          }
        ]
      }
    ]
  }
];

export const mockRawReportingFields = {
  entity: mockRawEntityReportingFields
};

export const mockTreeMetadataForEntityCriterion = [
  {
    text: 'Document type',
    value: 'DocumentType',
    selectable: false,
    visible: true,
    children: [
      {
        text: 'Administrative certificates',
        value: 'AdministrativeCertificatesCategory',
        data: 'DocumentType',
        selectable: false,
        visible: true,
        children: [
          {
            text: 'Company car',
            value: 'DescriptionCompanyCarCertificate',
            data: 'AdministrativeCertificatesCategory',
            selectable: true,
            visible: true,
            children: [],
            expanded: false
          }
        ],
        expanded: true
      }
    ],
    expanded: true
  }
];

export const mockEntityAccessCriterionPayload: RepPopulationCriterion = {
  entityType: 'Establishment',
  zoneName: 'LegalOrganization.Establishment.Country',
  groupZoneName: 'EstablishmentAddress',
  value: {
    'LegalOrganization.Establishment.Country': {
      value: 'FR',
      type: 'LIST',
      transId: 'France'
    }
  },
  access: 'READ'
};

export const mockCountryTreeMetadata = [
  {
    children: [],
    selectable: true,
    text: 'France',
    value: 'FR',
    visible: true
  },
  {
    children: [],
    selectable: true,
    text: 'India',
    value: 'IN',
    visible: true
  }
];

export const mockTreeMetadata = [
  {
    children: [],
    selectable: true,
    text: 'CDD',
    value: '005',
    visible: true
  },
  {
    children: [],
    selectable: true,
    text: 'Changement de statut CCSS',
    value: '013',
    visible: true
  },
  {
    children: [],
    selectable: false,
    text: 'Changement horaire de travail',
    value: '020',
    visible: true
  }
];
